const providers = ['sendpulse', 'mailchimp', 'pipedrive', 'brevo', 'api-access'];
const languages = ['en', 'el', 'de', 'it'];
const plugins = ['doitforme-crm-forms', 'doitforme-tracking'];

export const email_marketing_url = (provider, language, crmOrigin = window.location.origin) => {
    const base = process.env.REACT_APP_EMAIL_MARKETING_FRONTEND_URL;
    if (!base) throw new Error('Connection settings are not available in this environment.');
    const url = new URL(base);
    if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password) throw new Error('Invalid email marketing app URL.');
    const lang = languages.includes(language) ? language : 'en';
    const selection = plugins.includes(provider) ? `/${provider}` : '/manage';
    url.pathname = `/${lang}/integrations${selection}`;
    url.search = '';
    url.hash = '';
    if (providers.includes(provider)) url.searchParams.set('provider', provider);
    url.searchParams.set('returnTo', new URL(`/${lang}/crm`, crmOrigin).href);
    return url.href;
};

export const open_email_marketing = (provider, lang) => window.location.assign(email_marketing_url(provider, lang));
